<template>
  <div :id="'view-'+name" class="content-wrapper">
    <background-video-player
      :ref="videoPlayerId"
      :key="videoPlayerId"
      :videos="videoSource"
      :videoPlayerId="videoPlayerId"
    />
    <div class="msg-overlay"></div>
    <div class="pageTitle"></div>
    <hr class="titleSeparator">

    <div class="msg">
      <text-content key="msg1" v-if="init" :lines="msg1" :delay="textDelay"/>
      <text-content key="msg2" v-else :lines="msg2" :delay="textDelay"/>
      <hoverable-image :images="infoMarkImg" class="info-btn" @click.native="handleAction(info)"/>
    </div>

    <cf-button
      :width=280
      :key="'view-'+name+'-continue'"
      :id="'view-'+name+'-continue'"
      v-if="init"
      class="nav-btn btn-continue"
      @click.native="handleClick"
      :content="`Continue`"
    />
    <cf-button
      :width=400
      :key="'view-'+name+'-explore'"
      :id="'view-'+name+'-explore'"
      v-else      
      class="nav-btn btn-continue"
      @click.native="handleClick"
      animation
      :content="`Explore the upgrade`"
      :to="{name: 'Compare'}"
    />
  </div>
</template>

<script>
import HoverableSvg from "@/components/Hoverable-SVG";
import BackgroundVideoPlayer from "@/components/Background-Video-Player";
import HoverableImage from "@/components/Hoverable-Image";
import TextContent from "@/components/TextContent";
import CfButton from "@/components/CF-Button";
import BaseViewPage from "@/views/BaseViewPage";

export default {
  extends: BaseViewPage,
  components: {
    BackgroundVideoPlayer,
    CfButton,
    TextContent,
    HoverableSvg,
    HoverableImage
  },
  data() {
    return {
      init: true,
      message: [],
      msg1: [
        `Global Power Generation (GPG), a subsidiary of `,
        `Naturgy Energy Group, needed to increase capacity`,
        `to meet the energy demands of one million new`,
        `customers in Mexico.`
      ],
      msg2: [
        `GE’s cross-fleet team was tasked with upgrading`, 
        `GPG’s Tuxpan plant’s Mitsubishi M501F3 gas `,
        `turbines, which had been operating since 2001, `,
        `as well as its steam turbines, generator, and`,
        `combustion monitoring system.`
      ],
      info1: {
        gallery: {
          width: 1226,
          images: [
            {
              src: "./static/images/popup-01-gpg.png"
            }
          ]
        }
      },
      info2: {
        gallery: {
          width: 1226,
          images: [
            {
              src: "./static/images/popup-02-gpg.png"
            }
          ]
        }
      },
      navBtnImg: {
        imageSrc: "static/images/home/Btn1.png"
      },
      infoMarkImg: {
        imageSrc: "static/images/i.png"
      }
    };
  },
  computed: {
    delay() {
      // if from route is defined, i.e coming from a different page, then we need a bit delay for transition to happen
      // otherwise, if it is load directly, then there should not be delay.
      return this.$router.from? 3 : 2
    },
    textDelay() {
      let textDelay
      if( this.init ) {
        textDelay =  this.delay + 1.8
      } else {
        textDelay = 0
      }
      return textDelay
    }
  },
  methods: {
    handleClick() {      
      // pop a message dialog
      this.init = false;
      this.message = this.msg2;
      this.info = this.info2;
    },
    resetAnimation() {
      TweenMax.to(`#view-${this.name} .pageTitle`, 0, {css:{className:'-=loadingTitle'}});

      // TweenMax.killAll();
      TweenMax.from(`#view-${this.name} .msg-overlay`, 2, {
        left: -800,
        ease: Expo.easeOut,
        delay: this.delay
      });

      TweenMax.to(`#view-${this.name} .pageTitle`, 0, {css:{className:'+=loadingTitle'}, delay: this.delay+1});
      TweenMax.from(`#view-${this.name} .titleSeparator`, .5, {ease: "Expo.easeOut", opacity: 0, delay: this.textDelay});

      TweenMax.fromTo(
        `#view-${this.name} .info-btn`,
        1,
        { top: 30, opacity: 0 },
        { top: -50, ease: "Expo.easeOut", opacity: 1, delay: this.textDelay+0.2 }
      );
      TweenMax.fromTo(
        `#view-${this.name} .nav-btn`,
        1,
        { top: 960, opacity: 0 },
        { top: 910, ease: "Expo.easeOut", opacity: 1, delay: this.textDelay+0.4 }
      );
    },
    deactivated() {      
      
    },  
    activated() {
      this.init = true;
      this.message = this.msg1;
      this.info = this.info1;
      this.$emit("require-back-link", this.backLink);     
      this.$nextTick(() => {
        this.$refs[this.videoPlayerId].play();
        this.resetAnimation();
      });
    }
  }
};
</script>

<style lang="css" rel="stylesheet/css" scoped>
.btn-continue {
  left: 68px;
}
.info-btn {
  float: right;
  position: relative;
  cursor: pointer;
  top: -20px;
  right: 20px;
}

.info-btn {
  height: 40px !important;
  width: 40px !important;
}

.info-btn img{
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// index.vue?06e55b96